import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UploadedPhoto } from '../../prop-types';
import { DEFAULT_MODE } from '../../common/advanced-editor/constants';

import FilterButtons from '../../common/advanced-editor/filter-buttons';
import Button from '../../../_common/button';

export default function Filters({
  photo,
  effectUrls,
  handleEffect,
  handleEditMode,
  className,
}) {
  return (
    <div className={classNames('advanced-editor__filters mx-auto', className)}>
      <Button
        type="button"
        className="edit-btn back-button"
        aria-label="Back to edit buttons"
        hideLabel
        onClick={() => handleEditMode(DEFAULT_MODE)}
      />
      <FilterButtons
        key={photo.fx}
        defaultValue={photo.fx}
        urls={effectUrls}
        onChange={handleEffect}
      />
    </div>
  );
}

Filters.propTypes = {
  effectUrls: PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  }),
  photo: UploadedPhoto.isRequired,
  handleEffect: PropTypes.func.isRequired,
  handleEditMode: PropTypes.func.isRequired,
  className: PropTypes.string,
};

Filters.defaultProps = {
  className: '',
  effectUrls: {},
};
